<ng-container *ngIf="!data.withoutIcon" [ngSwitch]="data.type">
  <mat-icon class="icon mr-3" *ngSwitchCase="'success'" data-test-id="success-icon">check_circle</mat-icon>
  <mat-icon class="icon mr-3" *ngSwitchCase="'information'" data-test-id="info-icon">info</mat-icon>
  <mat-icon class="icon mr-3" *ngSwitchCase="'error'" data-test-id="error-icon">error</mat-icon>
</ng-container>

<div class="msg-wrapper">
  <span class="msg" data-test-id="message">{{ data.translate ? (data.msg | transloco) : data.msg }}</span>
  <span class="request-id" *ngIf="data.requestId" data-test-id="request-id">[id: {{ data.requestId }}]</span>
</div>

<button
  type="button"
  [title]="'close' | transloco"
  class="d-block close-icon pl-2"
  [inlineSVG]="'/icons/no-stroke-icon-close.svg'"
  (click)="close()"
  data-test-id="close-button"
></button>
